import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Button,
    Typography,
    MenuItem,
    InputLabel,
    FormControl,
    Select
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import "../../css/components/Modals/CreateNewSecret.css";
import "../../css/main.css";

export default function EditSecretModal({
    openEditModal,
    handleEditModalClose,
    handleUpdateSecret,
    secretData,
    myUserPerms
}) {
    const { t } = useTranslation();
    
    const getVisibilityOptions = () => {
        const options = [{ value: 'user', label: t("modal.user") }];
        
        // Include 'admin' if the user is admin or the secret's visibility is already 'admin'
        if (myUserPerms?.is_admin || myUserPerms?.is_owner || secretData?.type_of_visibility === 'admin') {
            options.push({ value: 'admin', label: t("modal.admin") });
        }
        
        // Include 'owner' if the user is owner or the secret's visibility is already 'owner'
        if (myUserPerms?.is_owner || secretData?.type_of_visibility === 'owner') {
            options.push({ value: 'owner', label: t("modal.owner") });
        }

        return options;
    };

    const [visibility, setVisibility] = useState(secretData?.type_of_visibility || "user");
    const [title, setTitle] = useState(secretData?.title || "");
    const [secret, setSecret] = useState(secretData?.secret || "");

    useEffect(() => {
        if (secretData) {
            setVisibility(secretData.type_of_visibility);
            setTitle(secretData.title);
            setSecret(secretData.secret);
        } else {
            setVisibility("user");
            setTitle("");
            setSecret("");
        }
    }, [secretData, openEditModal]);

    const handleVisibilityChange = (event) => {
        setVisibility(event.target.value);
    };

    const handleSave = () => {
        if (title.trim() === "" || secret.trim() === "") {
            return;
        }
        handleUpdateSecret(secretData.id, title, secret, visibility.toLowerCase());
        handleEditModalClose();
    };

    const renderVisibilityMessage = () => {
        switch (visibility) {
            case 'owner':
                return t("modal.secret_visibility_owner");
            case 'admin':
                return t("modal.secret_visibility_admin");
            case 'user':
            default:
                return t("modal.secret_visibility_user");
        }
    };

    return (
        <Dialog open={openEditModal} onClose={handleEditModalClose} className="modal-background-color">
            <DialogTitle>{t("modal.edit_secret")}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="title"
                    label={t("project_details.secret_title")}
                    type="text"
                    fullWidth
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    InputLabelProps={{
                        className: "white-txt-color"
                    }}
                    InputProps={{
                        className: "white-txt-color"
                    }}
                />
            </DialogContent>
            <DialogContent>
                <TextField
                    margin="dense"
                    id="secret"
                    label={t("project_details.secret_value")}
                    type="password"
                    fullWidth
                    value={secret}
                    onChange={(e) => setSecret(e.target.value)}
                    InputLabelProps={{
                        className: "white-txt-color"
                    }}
                    InputProps={{
                        className: "white-txt-color"
                    }}
                />
                <Typography className="create-secret-encrypt-info">
                    {t("modal.password_encrypt")}
                </Typography>
            </DialogContent>
            <DialogContent>
                <FormControl className="create-secret-form" fullWidth>
                    <InputLabel id="visibility-label" className="white-txt-color">
                        {t("global.visibility")}
                    </InputLabel>
                    <Select
                        labelId="visibility-label"
                        id="visibility"
                        value={visibility}
                        onChange={handleVisibilityChange}
                        label={t("global.visibility")}
                        MenuProps={{
                            PaperProps: {
                                className: "create-secret-select",
                            },
                        }}
                    >
                        {getVisibilityOptions().map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                    <Typography className="create-secret-encrypt-info">
                        {renderVisibilityMessage()}
                    </Typography>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleEditModalClose} className="button-dark-bg">
                    {t("global.cancel")}
                </Button>
                <Button
                    onClick={handleSave}
                    disabled={title.trim() === "" || secret.trim() === ""}
                    className="button-dark-bg"
                >
                    {t("modal.save_secret")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}